export const lcmsServices = {
  LCMS: {
    COURSES: {
      LIST: '/lcms/courses',
      OVERVIEW: '/lcms/overview',
      ADD: '/lcms/add',
      EDIT: '/lcms/update',
      DELETE: '/lcms/delete',
      DETAIL: '/lcms/detail',
      DETAIL_BY_LMS: '/lcms/detail/bylms',
      CHECK_IN_BEELAJAR: '/lcms/check-in',
      CHECK_OUT_BEELAJAR: '/lcms/check-out',
      ADD_HISTORY: '/lcms/add-history',
      LIST_HISTORY: '/lcms/list-history',
      LEVEL_OF_TRAINING: '/lcms/levels',
      MODE_OF_DELIVERY: '/lcms/mods',
      LEARNING_FORMAT: '/lcms/learning-formats',
      PASSING_FORMULA: '/lcms/passing-formulas',
      TRAINING_TYPE: '/lcms/training-types',
      BANDS: '/lcms/bands',
      LEARNING_PROGRAM: '/lcms/learning-programs',
      INTERNAL_EXTERNAL: '/lcms/internal-external',
      FACILITATOR: '/fma/facilitators',
      PIC_DETAIL: '/lcms/pic/detail',
      PIC_MATERIAL_DETAIL: '/lcms/pic/material-detail',
      PIC_SUMBIT_APPROVAL: '/lcms/pic/submit-approval',
      SME_SUBMIT_DETAIL: '/lcms/sme/submit/detail',
      SME_SUBMIT_MATERIAL: '/lcms/sme/submit',
      ADMIN_SUBMIT_MATERIAL: '/lcms/admin/upload-materi',
      SME_DELETE: '/lcms/sme/delete',
      TYPE_ACTIVITY: '/lcms/list-modules',
      SECTION_BY_COURSE: '/lcms/sections-by-course',
      COURSE_BY_MODULES: '/lcms/course-modules/by-modules',
      COURSE_CATEGORIES: '/lcms/course-categories',
      COMPETENCY_CATEGORIES: '/lcms/competencies-new',
      TAGS_LIST: '/lcms/tags',
      LCMS_BUSINESS_UNIT: '/lcms/business-units',
      LCMS_JOB_FAMILY_GROUPS: '/lcms/job-family-groups',
      LCMS_JOB_FAMILIES: '/lcms/job-families',
      LCMS_JOB_POSITION: '/lcms/job-positions',
      LCMS_JOB_PROFILES: '/lcms/job-profiles',
      BUSINESS_UNIT_CREATE_LCMS: '/lcms/business-units-create-course',
      GROUP_TRAININGS_COMMAND_CENTER: '/lcms/group-trainings/command-center'
    },
    TRAINING_CATALOGUE: {
      LIST: '/lcms/training-catalogue/list',
      DETAIL: '/lcms/training-catalogue/detail',
      PARTICIPANTS: '/lcms/training-catalogue/participants',
      DETAIL_COMPETENCY: '/lcms/training-catalogue/detail-competency'
    }
  }
};
